import React, { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import WizCredentialsForm from './WizCredentialsForm';
import WizMappingForm, {assetTypes, wizBucketAssetTypes} from './WizMappingForm';
import {map, find} from 'lodash';
import { CellRenderers, columnRenderArrayData } from 'utils/tableUtils'
import _ from "lodash";

const WizConfigListing = (props) => {
    const columns = useMemo(()=> [
        {
            title: "Project Name",
            dataIndex: "projectName",
            width: 120,
            render: CellRenderers.VALUE_OR_NA,
        }, {
            title: "Asset Type",
            dataIndex: "assetType",
            width: 120,
            render: value => {
                if(_.isEmpty(value)){
                    return CellRenderers.VALUE_OR_NA();
                }
                const assetType = map(value.split(','), val => find([...assetTypes, ...wizBucketAssetTypes], ['value', val]).label).join(',')       
                return columnRenderArrayData(assetType);
            },
            showFilter:false
        }
    ],[])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={WizMappingForm}
            CredentialsForm={WizCredentialsForm}
            extraColumns={columns}
        />
    )
};

export default WizConfigListing;